import { _ep0, _mw0, command } from "../commandBuilder";
import { AssumeRole$ } from "../schemas/schemas_0";
export class AssumeRoleCommand extends command(_ep0, _mw0, "AssumeRole", AssumeRole$) {
}
